import React from 'react';

const AlarmPage = () => {
  return (
    <div className="px-4">
      <div className="my-20">알람페이지~~</div>
    </div>
  );
};

export default AlarmPage;
